import styled from 'styled-components';

export const FAQContainer = styled.div`
  padding: 24px;
  border-radius: 20px;
  background: #fff;
`;

export const FAQSectionHeader = styled.h2`
  color: rgba(9, 21, 38, 0.85);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
`;

export const FAQSpoilerContentWrapper = styled.div`
  padding: 32px 0 8px 0;
  color: rgba(9, 21, 38, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  ol {
    list-style: decimal;
    padding-left: 1rem;
  }
  ul {
    list-style: disc;
    padding-left: 1rem;
  }
`;

export const MailToLink = styled.a`
  color: rgb(0, 147, 194);
  font-weight: bold;
  text-decoration: none;
  &:hover,
  &:visited {
    color: rgb(0, 147, 194);
    text-decoration: none;
  }
`;
